import React, { useEffect, useState } from 'react';
import { useWalletSelector } from '../context/WalletSelectorContext';
import {
  getHistoryOrder,
  OrderTxType,
  HistoryOrderSwapInfo,
  getHistoryOrderSwapInfo,
} from '../services/indexer';

export const useHistoryOrderTx = () => {
  const { accountId } = useWalletSelector();

  const [txIds, setTxIds] = useState<OrderTxType[] | null>(null);

  useEffect(() => {
    if (!accountId) return;

    getHistoryOrder(accountId).then((historyOrders) => {
      //@ts-ignore

      setTxIds(historyOrders?.data === null ? [] : historyOrders);
    });
  }, [accountId]);

  return txIds;
};

export const useHistoryOrderSwapInfo = ({
  start_at,
  end_at,
}: {
  start_at: number;
  end_at: number;
}) => {
  const { accountId } = useWalletSelector();

  const [swapInfo, setSwapInfo] = useState<HistoryOrderSwapInfo[] | null>([]);

  useEffect(() => {
    if (!accountId) return;

    getHistoryOrderSwapInfo(accountId).then((historySwapInfo) => {
      //@ts-ignore
      setSwapInfo(historySwapInfo?.data === null ? [] : historySwapInfo);
    });
  }, [accountId]);

  return (
    swapInfo?.filter(
      (swapInfoItem) =>
        Number(swapInfoItem.timestamp) >= start_at &&
        Number(swapInfoItem.timestamp) <= end_at
    ) || []
  );
};
